<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="900px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => $refs.detailForm.cancel()"
    destroy-on-close
    append-to-body
  >
    <DetailForm
      ref="detailForm"
      :disabled="disabled"
      :formData="formData"
      :productLine="productLine"
      :categoryCode="categoryCode"
      @close="close()"
      @reload="$emit('reload')"
      @change="onFormChange"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.detailForm.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.detailForm.save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import DetailForm from './index.vue'

export default {
  components: { DetailForm },
  props: {
    disabled: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    formData: { type: Object, default: () => {} },
    productLine: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
  },
  methods: {
    onFormChange(formData) {
      this.$emit('update:formData', formData)
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
